var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgException(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28134 9.29297V4.88672C9.28134 3.07453 7.81228 1.60547 6.00009 1.60547C4.18791 1.60547 2.71884 3.07453 2.71884 4.88672V9.29297H9.28134ZM6.00009 0.761719C3.72192 0.761719 1.87509 2.60854 1.87509 4.88672V8.96484L1.19723 9.8339C1.10119 9.95702 1.18893 10.1367 1.34507 10.1367H1.87509H10.1251H10.6551C10.8113 10.1367 10.899 9.95702 10.803 9.8339L10.1251 8.96484V4.88672C10.1251 2.60854 8.27827 0.761719 6.00009 0.761719ZM4.71094 10.8867C4.86526 11.454 5.38399 11.8711 6.00013 11.8711C6.61628 11.8711 7.135 11.454 7.28933 10.8867H4.71094ZM5.42418 3.90141C5.40582 3.57098 5.66882 3.29297 5.99975 3.29297C6.33069 3.29297 6.59368 3.57098 6.57533 3.90141L6.43147 6.49087C6.42595 6.59023 6.34377 6.66797 6.24426 6.66797H5.75525C5.65574 6.66797 5.57356 6.59023 5.56804 6.49087L5.42418 3.90141ZM5.57788 7.46484C5.57788 7.28363 5.72479 7.13672 5.906 7.13672H6.0935C6.27472 7.13672 6.42163 7.28363 6.42163 7.46484V7.65234C6.42163 7.83356 6.27472 7.98047 6.0935 7.98047H5.906C5.72479 7.98047 5.57788 7.83356 5.57788 7.65234V7.46484Z",
    fill: "#F32345"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgException);
export default __webpack_public_path__ + "static/media/exception.8cd94e11.svg";
export { ForwardRef as ReactComponent };